import { useState } from 'react';

import Link from 'next/link';

import Typography from '@components/Typography';
import CustomIcon from '@components/utils/CustomIcon';
import { CloseIcon } from '@assets/icons';
import Checkbox from '@components/Checkbox';
import { FlexibleDiv } from '@components/formStyles';
import { useAuthState } from '@contexts/auth/AuthContext';
import { logChatgptEvent } from '@utils/gtm/chatgpt-gtm';
import { setSafeLocalStorageItem } from '@utils/localStorage/getSafeLocalStorage';

import { AGE_LIMIT } from '../constants';
import {
  AgreeButton,
  CheckBoxItem,
  CheckBoxesWrapper,
  Container,
  Footer,
  Description,
  KVKKModalContent,
  Main,
  Header,
} from './styled';

type ChatGPTKVKKProps = {
  toggleVisible?: () => void;
  onKVKKAgree?: () => void;
};

export const ChatGPTKVKK = ({
  toggleVisible,
  onKVKKAgree,
}: ChatGPTKVKKProps) => {
  const [ageLimit, toggleAgeLimit] = useState(false);
  const { loginInfo } = useAuthState();
  const isLoggedIn = !!loginInfo?.token;

  const handleKVKKAgree = () => {
    if (!ageLimit) return;
    if (isLoggedIn) {
      setSafeLocalStorageItem('CHAPT_GPT_KVKK_AGREED', 'true');
    } else {
      sessionStorage.setItem('CHAPT_GPT_KVKK_AGREED', 'true');
    }
    logChatgptEvent('permission_given');
    onKVKKAgree?.();
    toggleVisible?.();
  };

  return (
    <Container>
      <KVKKModalContent>
        <Header>
          <Typography variant='caption' weight='Bold' color='D400'>
            Kişisel Verileriniz Hakkında
          </Typography>

          <CustomIcon
            icon={CloseIcon}
            fontSize={24}
            paletteColor='D400'
            clickable
            onClick={toggleVisible}
          />
        </Header>
        <Main>
          <Description>
            <FlexibleDiv bottom={10}>
              <Typography variant='caption2' weight='Regular' color='D300'>
                Setur Seyahat Asistanına Hoş Geldiniz!
              </Typography>
            </FlexibleDiv>
            <Typography variant='caption2' weight='Regular' color='D300' as='p'>
              Setur Seyahat Asistanı ile paylaştığınız kişisel verileriniz;
              Setur Servis Turistik Anonim Şirketi tarafından{' '}
              <Link
                href='https://www.setur.com.tr/seyahatasistani'
                target='_blank'
                rel='noopener noreferrer'
                prefetch={false}
              >
                Seyahat Asistanı Aydınlatma Metni
              </Link>{' '}
              kapsamında işlenecektir.
            </Typography>
          </Description>

          <CheckBoxesWrapper>
            <CheckBoxItem textHeight={36}>
              <Checkbox
                title={AGE_LIMIT}
                checked={ageLimit}
                onChange={(selected) => toggleAgeLimit(selected)}
              />
            </CheckBoxItem>
          </CheckBoxesWrapper>
        </Main>

        <Footer>
          <AgreeButton
            variant='Primary'
            disabled={!ageLimit}
            onClick={handleKVKKAgree}
          >
            <Typography variant='caption2' weight='Bold' color='NL0'>
              Seyahat Asistanı'na ilerle
            </Typography>
          </AgreeButton>
        </Footer>
      </KVKKModalContent>
    </Container>
  );
};

export default ChatGPTKVKK;
